export default async (response: Response) => {
  if (!response.ok) {
    const body = await response.json()
    // The company was archived mid-session: reload, so the app lands on one the user
    // can still reach (or on the no-company page)
    if (
      body.externalMessage === 'errors.company_archived' &&
      window.location.pathname !== '/error'
    ) {
      window.location.assign('/')
    }
    throw Error(body.externalMessage)
  }
  return response
}

export const errorMessages = (error: string) => {
  switch (error) {
    case 'errors.team_already_exists':
      return 'errorHandler.errorTeamEmojiFailed'
    case 'errors.engagement_survey_closed':
      return 'engagement.errors.surveyClosed'
    case 'errors.engagement_already_submitted':
      return 'engagement.errors.alreadySubmitted'
    case 'errors.engagement_survey_still_open':
      return 'engagement.errors.surveyStillOpen'
    case 'errors.engagement_survey_archived':
      return 'engagement.errors.surveyArchived'
    case 'errors.engagement_survey_not_found':
      return 'engagement.builder.notFound'
    case 'errors.engagement_template_not_found':
      return 'engagement.templates.notFound'
    case 'errors.engagement_invalid_end_date':
      return 'engagement.send.endDateInPast'
    case 'errors.engagement_invalid_audience':
      return 'engagement.errors.invalidAudience'
    case 'errors.engagement_link_busy':
      return 'engagement.errors.linkBusy'
    case 'errors.round_not_reopenable':
      return 'scripts.reopenRound.notReopenable'
    case 'errors.round_has_assessments':
      return 'scripts.reopenRound.hasAssessments'
    case 'errors.last_admin':
      return 'memberRights.lastAdmin'
    default:
      return 'errorHandler.errorOccured'
  }
}

// A survey's link that can no longer be filled in: closed, filed away, deleted or never there
export const isEngagementLinkExpired = (error: unknown) =>
  error instanceof Error && error.message === 'errors.engagement_link_expired'

// A survey or template that doesn't exist for this company, or a survey that wasn't
// sent to the member: not worth retrying, unlike a network or server error
export const isEngagementNotFound = (error: unknown) =>
  error instanceof Error &&
  [
    'errors.engagement_survey_not_found',
    'errors.engagement_template_not_found',
    'errors.engagement_not_a_respondent',
  ].includes(error.message)
